import { JsonRpcResponsePayload, JsonRpcError, JsonRpcRequestPayload } from './json-rpc-types';

export enum TronicIncomingWindowMessage {
  TRONIC_HANDLE_RESPONSE = 'TRONIC_HANDLE_RESPONSE',
  TRONIC_OVERLAY_READY = 'TRONIC_OVERLAY_READY',
  TRONIC_SHOW_OVERLAY = 'TRONIC_SHOW_OVERLAY',
  TRONIC_HIDE_OVERLAY = 'TRONIC_HIDE_OVERLAY',
  TRONIC_HANDLE_EVENT = 'TRONIC_HANDLE_EVENT',
  TRONIC_SEND_PRODUCT_ANNOUNCEMENT = 'TRONIC_SEND_PRODUCT_ANNOUNCEMENT',
}

export enum TronicOutgoingWindowMessage {
  TRONIC_HANDLE_REQUEST = 'TRONIC_HANDLE_REQUEST',
}

/** The shape of responding window message datas from the Tronic iframe context. */
export interface TronicMessageRequest {
  msgType: string;
  payload: JsonRpcRequestPayload | JsonRpcRequestPayload[];
  // rt?: string;
  jwt?: string;
}

/** The shape of responding window message datas from the Tronic iframe context. */
export interface TroincMessageResponse<ResultType = any> {
  msgType: string;
  response: Partial<JsonRpcError> & Partial<JsonRpcResponsePayload<ResultType>>;
  // rt?: string;
}

/** The expected message event returned by the Tronic iframe context. */
export interface TronicMessageEvent extends Partial<MessageEvent> {
  data: TroincMessageResponse;
}
